import { Segment } from '../../../types';

export const isPassengersHeightExceedViewport = (passengersRect: DOMRect) => {
	const segmentTabs = document.getElementById('segment-tabs') as HTMLDivElement;
	const toolbar = document.getElementById('toolbar') as HTMLDivElement;

	if (!segmentTabs || !toolbar) {
		return false;
	}

	const viewPort = toolbar.getBoundingClientRect().top - segmentTabs.getBoundingClientRect().bottom;
	const margin = 40;

	return passengersRect.height + margin > viewPort;
};

export const isSegmentSeatMapTooWide = (segment: Segment) => segment.decks[0]?.rows?.[0]?.seats?.length >= 10;
